import { Component, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '@core/services/auth.service';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { selectAuthUser } from '@state/auth/auth.selectors';

@Component({
  selector: 'app-verify-identity-phone-number-confirmation',
  templateUrl: './phone-number-confirmation.component.html',
  styleUrls: [
    '../email-confirmation/email-confirmation.component.scss',
    './phone-number-confirmation.component.scss',
  ],
})
export class VerifyIdentityPhoneNumberConfirmationComponent {
  @Input({ required: true }) confirmedAt: string | undefined | null;

  protected sending = false;
  protected user$ = this.store.select(selectAuthUser);
  protected showUpdatePhoneNumber = false;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private store: Store<AppState>
  ) {}

  requestNewLink() {
    this.sending = true;

    this.authService.sendPhoneNumberConfirmation().subscribe({
      next: (res) => {
        if (!res || res.sendPhoneNumberConfirmation !== 'OK') {
          this.sending = false;
          this.toastr.error(
            'Failed to send confirmation SMS. Please try again later.',
            'Error'
          );
          return;
        }
        this.sending = false;
        this.toastr.success('New confirmation SMS sent!', 'Success');
      },
      error: () => {
        this.sending = false;
        this.toastr.error(
          'Failed to send confirmation SMS. Please try again later.',
          'Error'
        );
      },
    });
  }
}
